import React from 'react';

const Features = () => {
  return (
    <section className="section features__v2" id="WhyChoose">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="d-lg-flex p-4 rounded-4 content" data-aos="fade-in" data-aos-delay={0}>
              <div className="row">
                <div className="col-lg-5 mb-5 mb-lg-0" data-aos="fade-up" data-aos-delay={0}>
                  <div className="row">
                    <div className="col-lg-11">
                      <div className="h-100 flex-column justify-content-between d-flex">
                        <div>
                          <h2 className="mb-4">Why Choose Our Cricket Academy</h2>
                          <p className="mb-5">
                            Our Cricket Academy helps players build strong fundamentals with structured coaching, match practice, and performance-focused training. Whether you're a beginner or aiming for competitive cricket, we guide you with the right plan and support.
                          </p>
                        </div>
                        <div className="align-self-start">
                          <a
                            className="glightbox btn btn-play d-inline-flex align-items-center gap-2"
                            href="https://www.youtube.com/watch?v=DQx96G4yHd8"
                            data-gallery="video"
                          >
                            <i className="bi bi-play-fill" /> Watch Training Session
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-7">
                  <div className="row justify-content-end">
                    <div className="col-lg-11">
                      <div className="row">
                        <div className="col-sm-6" data-aos="fade-up" data-aos-delay={0}>
                          <div className="icon text-center mb-4">
                            <i className="bi bi-person-check fs-4" />
                          </div>
                          <h3 className="fs-6 fw-bold mb-3">Certified Coaches</h3>
                          <p>Train with experienced coaches focused on technique, discipline, and match readiness.</p>
                        </div>

                        <div className="col-sm-6" data-aos="fade-up" data-aos-delay={100}>
                          <div className="icon text-center mb-4">
                            <i className="bi bi-graph-up fs-4" />
                          </div>
                          <h3 className="fs-6 fw-bold mb-3">Performance Tracking</h3>
                          <p>Regular assessments with feedback to improve batting, bowling, fielding, and fitness.</p>
                        </div>

                        <div className="col-sm-6" data-aos="fade-up" data-aos-delay={200}>
                          <div className="icon text-center mb-4">
                            <i className="bi bi-headset fs-4" />
                          </div>
                          <h3 className="fs-6 fw-bold mb-3">Personalized Training Plans</h3>
                          <p>Age-wise and skill-wise training plans with individual attention and goal-based sessions.</p>
                        </div>

                        <div className="col-sm-6" data-aos="fade-up" data-aos-delay={300}>
                          <div className="icon text-center mb-4">
                            <i className="bi bi-shield-lock fs-4" />
                          </div>
                          <h3 className="fs-6 fw-bold mb-3">Match Practice & Tournaments</h3>
                          <p>Net sessions, match simulations, and tournament opportunities to build confidence.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
